// extracted by mini-css-extract-plugin
export default {"ConfirmModal":"ConfirmModal_ConfirmModal__dtfgD"};